"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flipOut = exports.flipIn = exports.flip = void 0;

var _index = require("../../../styles/index"); // -------------------------------------------
//   ANIMATIONS > FLIP
// -------------------------------------------
// (((((((((( ~~~~~~~~~~ FLIP ~~~~~~~~~~ )))))))))) //


var flip = {
  // ***** FLIP (horizontal) ***** //
  '@keyframes flip': {
    from: {
      transform: (0, _index.replacePXinStringWithEM)('perspective(400px) rotate3d(0, 1, 0, -360deg)'),
      animationTimingFunction: 'ease-out'
    },
    '40%': {
      transform: (0, _index.replacePXinStringWithEM)('perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg)'),
      animationTimingFunction: 'ease-out'
    },
    '50%': {
      transform: (0, _index.replacePXinStringWithEM)('perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg)'),
      animationTimingFunction: 'ease-in'
    },
    '80%': {
      transform: (0, _index.replacePXinStringWithEM)('perspective(400px) scale3d(.95, .95, .95)'),
      animationTimingFunction: 'ease-in'
    },
    to: {
      transform: (0, _index.replacePXinStringWithEM)('perspective(400px)'),
      animationTimingFunction: 'ease-in'
    }
  }
}; // (((((((((( ~~~~~~~~~~ FLIP IN ~~~~~~~~~~ )))))))))) //

exports.flip = flip;
var flipIn = {
  // ***** FLIP : IN : Y ***** //
  '@keyframes flipInY': {
    from: {
      transform: (0, _index.replacePXinStringWithEM)('perspective(400px) rotate3d(1, 0, 0, 90deg)'),
      animationTimingFunction: 'ease-in',
      opacity: '0'
    },
    '40%': {
      transform: (0, _index.replacePXinStringWithEM)('perspective(400px) rotate3d(1, 0, 0, -20deg)'),
      animationTimingFunction: 'ease-in'
    },
    '60%': {
      transform: (0, _index.replacePXinStringWithEM)('perspective(400px) rotate3d(1, 0, 0, 10deg)'),
      opacity: '1'
    },
    '80%': {
      transform: (0, _index.replacePXinStringWithEM)('perspective(400px) rotate3d(1, 0, 0, -5deg)')
    },
    to: {
      transform: (0, _index.replacePXinStringWithEM)('perspective(400px)')
    }
  },
  // ***** FLIP : IN : X ***** //
  '@keyframes flipInX': {
    from: {
      transform: (0, _index.replacePXinStringWithEM)('perspective(400px) rotate3d(0, 1, 0, 90deg)'),
      animationTimingFunction: 'ease-in',
      opacity: '0'
    },
    '40%': {
      transform: (0, _index.replacePXinStringWithEM)('perspective(400px) rotate3d(0, 1, 0, -20deg)'),
      animationTimingFunction: 'ease-in'
    },
    '60%': {
      transform: (0, _index.replacePXinStringWithEM)('perspective(400px) rotate3d(0, 1, 0, 10deg)'),
      opacity: '1'
    },
    '80%': {
      transform: (0, _index.replacePXinStringWithEM)('perspective(400px) rotate3d(0, 1, 0, -5deg)')
    },
    to: {
      transform: (0, _index.replacePXinStringWithEM)('perspective(400px)')
    }
  }
}; // (((((((((( ~~~~~~~~~~ FLIP OUT ~~~~~~~~~~ )))))))))) //

exports.flipIn = flipIn;
var flipOut = {
  // ***** FLIP : OUT : Y ***** //
  '@keyframes flipOutY': {
    from: {
      transform: (0, _index.replacePXinStringWithEM)('perspective(400px)')
    },
    '30%': {
      transform: (0, _index.replacePXinStringWithEM)('perspective(400px) rotate3d(0, 1, 0, -15deg)'),
      opacity: '1'
    },
    to: {
      transform: (0, _index.replacePXinStringWithEM)('perspective(400px) rotate3d(0, 1, 0, 90deg)'),
      opacity: '0'
    }
  },
  // ***** FLIP : OUT : X ***** //
  '@keyframes flipOutX': {
    from: {
      transform: (0, _index.replacePXinStringWithEM)('perspective(400px)')
    },
    '30%': {
      transform: (0, _index.replacePXinStringWithEM)('perspective(400px) rotate3d(1, 0, 0, -20deg)'),
      opacity: '1'
    },
    to: {
      transform: (0, _index.replacePXinStringWithEM)('perspective(400px) rotate3d(1, 0, 0, 90deg)'),
      opacity: '0'
    }
  }
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

exports.flipOut = flipOut;